import { Injectable } from '@angular/core';
import { ApiConService } from '../shared/api-con.service';

@Injectable()
export class BoxGraphicStatisticService {

  constructor(private conService: ApiConService) { }

}
